import { supabase } from "./supabase";

class WishlistService {
  // Get user's wishlist from Supabase
  // In wishlistService.js - add pagination
async getWishlist(userId, limit = 100, offset = 0) {
  try {
    const { data, error } = await supabase
      .from("wishlists")
      .select("product_asin, added_at")
      .eq("user_id", userId)
      .order("added_at", { ascending: false })
      .range(offset, offset + limit - 1);

    if (error) throw error;

    const asins = (data || []).map(item => item.product_asin);
    console.log("Wishlist fetched from Supabase:", asins.length, "items");
    return asins;
  } catch (error) {
    console.error("Failed to fetch wishlist:", error);
    return [];
  }
}

  // Add item to wishlist
  async addToWishlist(userId, productAsin) {
    try {
      const { error } = await supabase
        .from("wishlists")
        .insert({
          user_id: userId,
          product_asin: productAsin,
        });

      if (error) throw error;
      console.log("Added to wishlist:", productAsin);
      return true;
    } catch (error) {
      console.error("Error adding to wishlist:", error);
      return false;
    }
  }

  // Remove item from wishlist
  async removeFromWishlist(userId, productAsin) {
    try {
      const { error } = await supabase
        .from("wishlists")
        .delete()
        .eq("user_id", userId)
        .eq("product_asin", productAsin);

      if (error) throw error;
      console.log("Removed from wishlist:", productAsin);
      return true;
    } catch (error) {
      console.error("Error removing from wishlist:", error);
      return false;
    }
  }

  // Clear entire wishlist
  async clearWishlist(userId) {
    try {
      const { error } = await supabase
        .from("wishlists")
        .delete()
        .eq("user_id", userId);

      if (error) throw error;
      console.log("Wishlist cleared");
      return true;
    } catch (error) {
      console.error("Error clearing wishlist:", error);
      return false;
    }
  }
}

export const wishlistService = new WishlistService();